import { z } from 'zod';

export const partnerSchema = z.object({
  partnerId: z.string().min(1),
  partnerName: z.string().min(1),
});

export const partnersSchema = z.array(partnerSchema);

export type Partner = z.infer<typeof partnerSchema>;

export type Partners = z.infer<typeof partnersSchema>;
